import { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';
import { environment } from '../../environments/environment';

export const keycloakConfig: KeycloakConfig = {
  url: environment.auth.authority,
  realm: environment.auth.realm,
  clientId: environment.auth.clientId,
};

export const keycloakInitOptions: KeycloakInitOptions = {
  onLoad: 'check-sso',
  pkceMethod: 'S256',
  silentCheckSsoRedirectUri: window.location.origin + '/silent-refresh.html',
  redirectUri: environment.auth.redirectUri,
  // Desactiva el polling continuo por iframe. El silent-check solo se hace
  // en la inicialización, no en cada comprobación de sesión posterior.
  // Evita que Brave y otros navegadores con shields bloqueen la app.
  checkLoginIframe: false,
};
